// Mock data for EJ Wilson Productions

export const bioData = {
  name: "Eddie J. Wilson",
  title: "The Actor, The Writer, The Visionary",
  image: "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/aoytbl8w_file_00000000cd68722fa68aa051004c9641.png",
  bio: "Eddie J. Wilson is a multifaceted creative force in the entertainment industry, bringing stories to life through film, and stage. With a passion for storytelling that transcends mediums, Eddie has dedicated his career to creating impactful narratives that resonate with audiences worldwide.",
  achievements: [
    "Award-winning film producer and director",
    "Acclaimed stage actor and playwright",
    "Published author and screenwriter",
    "Founder of EJ Wilson Productions"
  ]
};

export const services = [
  {
    id: 1,
    title: "Film Production",
    description: "From concept to screen, we bring cinematic visions to life with professional production services.",
    icon: "Film"
  },
  {
    id: 2,
    title: "Acting Services",
    description: "Professional acting talent for film, television, commercials, and theatrical productions.",
    icon: "Theater"
  },
  {
    id: 3,
    title: "Stage Plays",
    description: "Original theatrical productions that captivate audiences and tell compelling stories.",
    icon: "Drama"
  }
];

export const portfolio = [
  {
    id: 1,
    title: "Legacies",
    type: "Short Silent Film",
    description: "A powerful silent film exploring themes of heritage, memory, and the stories we leave behind.",
    videoUrl: "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/51d7pag2_LegaciesShortSilentFilm.mp4",
    category: "Film Production"
  },
  {
    id: 2,
    title: "TORN",
    type: "Short Film 2020",
    description: "A compelling dramatic narrative that captures the complexities of human emotion and conflict.",
    videoUrl: "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/32621vim_TORN%202020%20Short%20Film.mp4",
    category: "Film Production"
  },
  {
    id: 3,
    title: "Even Xchange",
    type: "Film Production",
    description: "A captivating cinematic experience that showcases compelling storytelling and visual artistry.",
    videoUrl: "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/mtn2es18_EvenXchange.mp4",
    category: "Film Production"
  },
  {
    id: 4,
    title: "Theatrical Performance",
    type: "Stage Play",
    description: "Dynamic stage performances that bring characters and stories to life.",
    category: "Acting",
    images: [
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/c639q8xl_Screenshot_20210302-125639_Instagram.jpg",
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/r0w3jr7m_Screenshot_20210302-125523_Instagram.jpg",
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/mha5jlkg_Screenshot_20210302-130203_Messenger.jpg",
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/nb4mmfhc_Screenshot_20210302-130356_Messenger.jpg",
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/zq87a0ql_Screenshot_20210302-125712_Instagram.jpg",
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/ubn572fs_Screenshot_20210325-215212_Messenger.jpg",
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/h247njn3_LUM2%20%2811%29.jpg",
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/y5phx2hq_LUM2%20%288%29.jpg",
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/6kdz7k7l_LUM1%20%281%29.jpg",
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/0bm7vkk0_LUM1.jpg"
    ]
  },
  {
    id: 5,
    title: "Original Productions",
    type: "Creative Works",
    description: "Original scripts and productions showcasing unique storytelling.",
    category: "Writing",
    images: [
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/sntndj69_Screenshot_20240702_081136_Lensa.jpg",
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/cwyrth3d_Screenshot_20200917-165804_Facebook.jpg",
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/yno2schy_Screenshot_20241208_202127_Facebook.jpg",
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/yltusdpx_FB_IMG_1647525172424.jpg",
      "https://customer-assets.emergentagent.com/job_stage-and-screen/artifacts/jz365gd9_FB_IMG_1739766343059.jpg"
    ]
  }
];

export const upcomingEvents = [
  {
    id: 1,
    title: "Film Screening & Q&A",
    date: "TBA",
    venue: "TBA",
    price: "$25 - $75",
    description: "Experience our latest film followed by an intimate discussion with the cast and crew."
  },
  {
    id: 2,
    title: "Summer Stage Series",
    date: "TBA",
    venue: "TBA",
    price: "$30 - $100",
    description: "A season of captivating performances under the stars."
  }
];

export const donationTiers = [
  {
    id: 1,
    name: "Supporter",
    amount: 50,
    benefits: ["Name in program credits", "Email updates"]
  },
  {
    id: 2,
    name: "Patron",
    amount: 100,
    benefits: ["All Supporter benefits", "Exclusive behind-the-scenes content", "Priority ticket access"]
  },
  {
    id: 3,
    name: "Benefactor",
    amount: 500,
    benefits: ["All Patron benefits", "VIP event invitations", "Meet & greet opportunities"]
  },
  {
    id: 4,
    name: "Philanthropist",
    amount: 1000,
    benefits: ["All Benefactor benefits", "Cameo appearance", "Private screenings", "Special thanks in movie credits"]
  }
];